<div class="container single-view" id="view-distribution-channel">
  <div class="row">
    <div class="col-12 mb-4 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/distribution-channels" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'DISTRIBUTION_CHANNELS.BTN_BACK_TO_DISTRIBUTION_CHANNEL' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-baseline justify-between gap-4">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="distributionchannel-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'DISTRIBUTION_CHANNEL_SINGLE_VIEW.DISTRIBUTION_CHANNEL_DETAILS' | translate }}
            </h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (distributionChannel.name) {
                  <span data-testid='distributionchannel-name'>{{ distributionChannel.name | defaultValue }}</span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex flex-wrap"></div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (allowModifyDistributionChannel) {
              <button data-testid='distributionchannel-edit-btn' class="btn primary-btn" (click)="goToEditDistributionChannel()">{{ 'DISTRIBUTION_CHANNEL_SINGLE_VIEW.BTN_EDIT' | translate }}</button>
            }
            @if (delete) {
              <button data-testid='distributionchannel-delete-btn' class="btn red-btn" (click)="showDeleteDialog()">{{'DISTRIBUTION_CHANNELS.BTN_DELETE' | translate }}</button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-4 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <section class="row">
              <div class="col-12">
                <h4 data-testid='distributionchannel-details'>{{ 'DISTRIBUTION_CHANNEL_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">
                  <dt data-testid='distributionchannel-name-label' class="label grid-cols-1 pt-3">{{ 'DISTRIBUTION_CHANNEL_SINGLE_VIEW.NAME' | translate }}</dt>
                  <dd data-testid='distributionchannel-name' class="value pt-3 pb-3">{{ distributionChannel.name | defaultValue }}</dd>

                  <dt data-testid='distributionchannel-code-label' class="label grid-cols-1 pt-3">{{ 'DISTRIBUTION_CHANNEL_SINGLE_VIEW.CODE' | translate }}</dt>
                  <dd data-testid='distributionchannel-code' class="value pt-3 pb-3">{{ distributionChannel.code | defaultValue }}</dd>
                </dl>
              </div>
            </section>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete distribution channel -->
<dialog-reason  #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_RETAILER'" (onClose)="deleteDistributionChannel($event)"></dialog-reason>
